// NOTE: components
import Skeleton from '../../components/ui/Skeleton'

// NOTE: the assessment opens on the two routes and a start button, so the fallback mirrors that screen only
const FLOW_PLACEHOLDERS = [{ id: 'full' }, { id: 'light' }]

const AssessmentSkeleton = () => (
	<section
		role="status"
		aria-label="Loading assessment"
		className="mx-auto w-full max-w-2xl px-5 pb-20 pt-6 sm:px-8"
	>
		{/* Logo */}
		<Skeleton className="mb-[34px] h-[26px] w-[80px]" />

		{/* Title */}
		<div className="mb-4">
			<Skeleton className="mb-2 h-[37px] w-full sm:h-[45px]" />
			<Skeleton className="h-[37px] w-3/5 sm:h-[45px]" />
		</div>

		{/* Dek */}
		<div className="mb-8 max-w-xl">
			<Skeleton className="mb-2.5 h-6 w-full" />
			<Skeleton className="h-6 w-4/5" />
		</div>

		{/* Routes */}
		<div className="flex gap-3.5">
			{FLOW_PLACEHOLDERS.map(({ id }) => (
				<Skeleton key={id} className="h-[196px] flex-1 rounded-2xl" />
			))}
		</div>

		{/* Pagination */}
		<Skeleton className="mx-auto mt-[13px] h-2.5 w-[40px] rounded-full" />

		{/* Start */}
		<Skeleton className="mt-8 h-[70px] w-full rounded-[10px]" />
	</section>
)

export default AssessmentSkeleton
